import {
  ComponentType,
  lazy,
  PropsWithoutRef,
  Suspense,
  SuspenseProps,
} from 'react';
import ErrorBoundary, { ErrorBoundaryProps } from '../ErrorBoundary';
import { Loader } from './Loader';
import { lazyRetry } from './Loadable.utils';

export interface LoadableProps<Props extends object>
  extends ErrorBoundaryProps {
  component: () => Promise<{ default: ComponentType<Props> }>;
  componentProps?: Props;
  loader?: SuspenseProps['fallback'];
}

function Loadable<Props extends object>({
  component,
  componentProps,
  loader,
  ...errorBoundaryProps
}: LoadableProps<Props>) {
  const Component = lazy(() => lazyRetry(component));

  return (
    <Suspense fallback={loader || <Loader />}>
      <ErrorBoundary {...errorBoundaryProps}>
        <Component {...(componentProps as PropsWithoutRef<Props>)} />
      </ErrorBoundary>
    </Suspense>
  );
}

export default Loadable;
